module.exports = __webpack_public_path__ + "media/app/components/TagsNavBar/superSaving.35c6d922.svg";